
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-flipper",
      function () {
        return require("private-next-pages/image-flipper.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-flipper"])
      });
    }
  